import type { ListResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ListImportQueryGateway } from './list-import-query';

/**
 * Real HTTP implementation of the wizards' import-from-list reads. Path building
 * is kept 1:1 with the original step component (notably `origin` is always sent,
 * even when it is `all`) so the server sees identical requests.
 */
export const listImportQueryHttp: ListImportQueryGateway = {
  fetchSourceLists: ({ origin, licenceId }) => {
    const params = new URLSearchParams();
    params.set('origin', origin);
    if (licenceId) params.set('licence_id', licenceId);
    return api.get<ListResponse[]>(`/lists?${params.toString()}`);
  },

  fetchListProfileIds: async (listId) => {
    const res = await api.get<{ profile_ids: string[]; count: number }>(
      `/lists/${listId}/profile-ids`,
    );
    return res.profile_ids;
  },

  checkImportDuplicates: async (profileIds, licenceId) => {
    const res = await api.post<{ duplicate_ids: string[]; duplicate_count: number }>(
      '/lists/check-import-duplicates',
      { profile_ids: profileIds, licence_id: licenceId },
    );
    return { duplicateIds: res.duplicate_ids, duplicateCount: res.duplicate_count };
  },
};
